module.exports = __webpack_public_path__ + "static/media/city_studio.4a2f9af1.png";